import React from "react";

function CreateTicket() {
    return (
        <div className="container">
            <div className="row">
                <h3 className="text-muted mb-5">To create a ticket, select a relevant topic</h3>
                <div className="col-4 p-4">
                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-plus-circle" aria-hidden="true"></i>Account Opening</a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Resident individual</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Minor</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Non Resident Indian (NRI)</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Company, Partnership, HUF and LLP</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Glossary</a><br />
                </div>
                <div className="col-4 p-4">


                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-user" aria-hidden="true"></i>Your Zerodha Account</a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Your Profile</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "1.5", marginLeft: "1rem" }}>Client Master Report (CMR) and Depository  <span style={{marginLeft:"1rem"}}>Participant (DP)</span>

                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Nomination
                    </a><br />

                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Transfer and conversion of securities
                    </a><br />
                </div>
                <div className="col-4 p-4">
                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-bar-chart" aria-hidden="true"></i>                    Kite
                    </a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>IPO
                    </a><br />

                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Trading FAQs
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Margin Trading Facility (MTF) and Margins

                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Alerts and Nudges


                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        General
                    </a><br />
                </div>
            </div>



            <div className="row">
                <div className="col-4 p-4">


                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-plus-circle" aria-hidden="true"></i>Funds</a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>                    Add money
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Withdraw money
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Add bank accounts</a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>eMandates</a><br />

                </div>
                <div className="col-4 p-4">

                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-plus-circle" aria-hidden="true"></i>                     Console
                    </a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Portfolio
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Corporate actions


                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Funds statement
                    </a><br />

                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Reports
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Profile
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Segments
                    </a><br />

                </div>
                <div className="col-4 p-4">
                    <h4> <a href="" style={{ textDecoration: "none", color: "black" }}><i class="fa fa-plus-circle" aria-hidden="true"></i>                                          Coin

                    </a></h4>
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>Mutual funds

                    </a><br />

                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        National Pension Scheme (NPS)

                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Fixed Deposit (FD)
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Features on Coin
                    </a><br />
                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        Payments and Orders
                    </a><br />

                    <a href="" style={{ textDecoration: "none", lineHeight: "2.5", marginLeft: "1rem" }}>
                        General

                    </a><br />
                </div>
            </div>
        </div>
    );
}

export default CreateTicket;